import { PROPERTY_ONBOARD } from '../constants';
import validateCountryIsoCode from './validateCountryIsoCode';

const getCountryIsoCodeFromLocationPath = path => {
  if (path) {
    const pathParam = path.split('/');
    let index = 0;
    while (index < pathParam.length) {
      if (pathParam[index] === PROPERTY_ONBOARD) {
        index++;
        break;
      }
      index++;
    }
    if (index < pathParam.length && validateCountryIsoCode(pathParam[index])) {
      return pathParam[index];
    }
    return '';
  }
  return '';
}

export default getCountryIsoCodeFromLocationPath;
